module.exports = __webpack_public_path__ + "img/bus_day_up_selected.cd2683cd.svg";